/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Publicly_List_Resource_HintInputs */

const en_admin_resource_form_publicly_list_resource_hint = /** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase occupancy and revenue by making this resource available for non-member bookings`)
};

const de_admin_resource_form_publicly_list_resource_hint = /** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höherer Umsatz durch optimale Auslastung: Diese Ressource für Buchungen von Nicht-Mitgliedern verfügbar machen`)
};

const es_admin_resource_form_publicly_list_resource_hint = /** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimiza la ocupación y aumenta los ingresos con este recurso: hazlo disponible para reservas de no miembros`)
};

const fr_admin_resource_form_publicly_list_resource_hint = /** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimisez l'occupation et augmentez les revenus avec cette ressource : Rendez-la disponible pour les réservations de non-membres`)
};

/** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */
const it_admin_resource_form_publicly_list_resource_hint = en_admin_resource_form_publicly_list_resource_hint;

/** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_publicly_list_resource_hint = en_admin_resource_form_publicly_list_resource_hint;

/** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */
const pl_admin_resource_form_publicly_list_resource_hint = en_admin_resource_form_publicly_list_resource_hint;

/** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */
const hu_admin_resource_form_publicly_list_resource_hint = en_admin_resource_form_publicly_list_resource_hint;

/** @type {(inputs: Admin_Resource_Form_Publicly_List_Resource_HintInputs) => LocalizedString} */
const ro_admin_resource_form_publicly_list_resource_hint = en_admin_resource_form_publicly_list_resource_hint;

/**
* | output |
* | --- |
* | "Increase occupancy and revenue by making this resource available for non-member bookings" |
*
* @param {Admin_Resource_Form_Publicly_List_Resource_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_publicly_list_resource_hint = /** @type {((inputs?: Admin_Resource_Form_Publicly_List_Resource_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Publicly_List_Resource_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_publicly_list_resource_hint(inputs)
	if (locale === "de") return de_admin_resource_form_publicly_list_resource_hint(inputs)
	if (locale === "es") return es_admin_resource_form_publicly_list_resource_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_publicly_list_resource_hint(inputs)
	if (locale === "it") return it_admin_resource_form_publicly_list_resource_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_publicly_list_resource_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_publicly_list_resource_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_publicly_list_resource_hint(inputs)
	return ro_admin_resource_form_publicly_list_resource_hint(inputs)
});
export { admin_resource_form_publicly_list_resource_hint as "admin.resource_form.publicly_list_resource_hint" }